module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 47.47 57.62"
    }
  }, [_c('title', [_vm._v("items-list_icon")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_4",
      "data-name": "Layer 4"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M4.49,4.78c-2.93,0-2.66,2.45-2.66,8.76V45.06c0,11.77-.66,10.71,11.12,10.71H35.51c11.78,0,10.05,1.06,10.05-10.71V13.54c0-6.49.32-9.06-2.85-9.06",
      "fill": "#fff",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.65"
    }
  }), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "38.87",
      "y1": "1.82",
      "x2": "38.87",
      "y2": "7.3",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.65"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "31.22",
      "y1": "1.82",
      "x2": "31.22",
      "y2": "7.3",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.65"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "23.56",
      "y1": "1.82",
      "x2": "23.56",
      "y2": "7.3",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.65"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15.91",
      "y1": "1.82",
      "x2": "15.91",
      "y2": "7.3",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.65"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8.25",
      "y1": "1.82",
      "x2": "8.25",
      "y2": "7.3",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.65"
    }
  })]), _vm._v(" "), _c('g', [_c('line', {
    attrs: {
      "x1": "20.85",
      "y1": "47.31",
      "x2": "39.07",
      "y2": "47.31",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.49"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20.85",
      "y1": "36.37",
      "x2": "39.07",
      "y2": "36.37",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.49"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20.85",
      "y1": "25.44",
      "x2": "39.07",
      "y2": "25.44",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.49"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20.85",
      "y1": "14.5",
      "x2": "39.07",
      "y2": "14.5",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.49"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    attrs: {
      "points": "8.62 47.63 10.75 49.27 14.17 45.5",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.49"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "8.62 36.69 10.75 38.33 14.17 34.56",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.49"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "8.62 25.76 10.75 27.39 14.17 23.63",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.49"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "8.62 14.82 10.75 16.46 14.17 12.69",
      "fill": "none",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "3.49"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ee086d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/ItemsIcon.vue
// module id = 3231
// module chunks = 0